// Mesmos nomes no portal, em Minha conta e nos e-mails.
export const STATUS_TIMELINE = [
  { id: "created", label: "Em análise", values: ["Solicitado", "Em análise"] },
  { id: "awaiting", label: "Enviar produto", values: ["Aguardando postagem"] },
  { id: "transit", label: "A caminho da loja", values: ["Em trânsito"] },
  { id: "review", label: "Conferência", values: ["Produto recebido, aguardando validação", "Em disputa"] },
  { id: "done", label: "Concluída", values: ["Concluído"] },
];

function formatDate(value) {
  if (!value) return "";
  if (/^\d{4}-\d{2}-\d{2}/.test(value)) return value.slice(0, 10).split("-").reverse().join("/");
  return String(value);
}

/** O que o cliente precisa saber/fazer agora, em uma frase. */
export function nextStepText(occurrence = {}) {
  const status = occurrence.statusOccurrence || "Solicitado";
  const code = occurrence.postReverse?.postCode || occurrence.postCode;
  const until = formatDate(occurrence.postReverse?.expireDate || occurrence.postReverse?.expire);
  if (status === "Solicitado" || status === "Em análise") {
    return code ? "Leve o produto aos Correios com o código abaixo." : "A loja está analisando. Avisamos por e-mail quando aprovar.";
  }
  if (status === "Aguardando postagem") {
    if (occurrence.keepItem) return "Você não precisa devolver o produto. A loja vai liberar a resolução.";
    return until ? `Leve o produto a uma agência dos Correios até ${until}.` : "Leve o produto a uma agência dos Correios.";
  }
  if (status === "Em trânsito") return "Seu produto está a caminho da loja. Não precisa fazer nada.";
  if (status === "Produto recebido, aguardando validação" || status === "Em disputa") {
    return "A loja recebeu o produto e está conferindo.";
  }
  if (status === "Concluído") {
    if (occurrence.resolutionType === "exchange") return "Troca concluída. O produto novo segue para o seu endereço.";
    if (occurrence.resolutionType === "refund") return "Estorno feito. No cartão, pode levar até duas faturas para aparecer.";
    return "Concluída. O crédito, vale ou cupom foi enviado para o seu e-mail.";
  }
  return "";
}

export function statusLabel(status) {
  if (/instant/i.test(status || "") || /troca instant/i.test(status || "")) {
    return "Troca instantânea";
  }
  if (/aprovad[oa] automaticamente/i.test(status || "")) {
    return "Aprovada automaticamente";
  }
  const found = STATUS_TIMELINE.find((step) => step.values.includes(status));
  if (status === "Prazo expirado") {
    return "Prazo expirado";
  }
  if (status === "Solicitado") {
    return "Aguardando aprovação da loja";
  }
  if (status === "Recusado") {
    return "Não aprovada";
  }
  if (status === "Cancelado") {
    return "Cancelada";
  }
  if (status === "Erro") {
    return "Erro";
  }
  return found?.label || status || "Solicitado";
}

export function approvalNotice(result) {
  if (!result || typeof result !== "object") {
    return null;
  }
  const blob = [
    result.statusOccurrence,
    result.status,
    result.approval,
    result.approvalType,
    result.exchangeType,
  ].filter(Boolean).join(" ");
  const instant = result.instantExchange === true
    || result.trocaInstantanea === true
    || result.instant === true
    || /instant/i.test(blob)
    || /troca instant/i.test(blob);
  const auto = result.autoApproved === true
    || result.automaticApproval === true
    || result.approvedAutomatically === true
    || result.aprovadoAutomaticamente === true
    || result.auto_approved === true
    || /aprovad[oa] automaticamente/i.test(blob);
  if (instant) {
    return {
      kind: "instant",
      title: "Troca instantânea",
      text: "A loja aprovou a troca na hora. Acompanhe o envio do item novo neste status.",
    };
  }
  if (auto) {
    return {
      kind: "auto",
      title: "Aprovada automaticamente",
      text: "Sua solicitação já foi aprovada. Leve o código abaixo aos Correios para postar.",
    };
  }
  return null;
}

export function statusIndex(status) {
  if (!status || status === "Erro" || status === "Prazo expirado") {
    return 0;
  }
  const index = STATUS_TIMELINE.findIndex((step) => step.values.includes(status));
  return index >= 0 ? index : 1;
}

export function trackingUrl(code) {
  if (!code) {
    return "";
  }
  return `https://rastreamento.correios.com.br/app/index.php?objetos=${encodeURIComponent(code)}`;
}

export function occurrenceErrorMessage(error) {
  const status = error?.response?.status;
  const api = error?.response?.data?.message || error?.response?.data?.error;
  const code = error?.response?.data?.code || error?.response?.data?.errorCode;
  const policyHit = /pol[ií]tica|policy|same_product|up_to_same_price|any_product|exchange/i.test(`${api || ""} ${code || ""}`);
  if (status === 400 && (code === "EXCHANGE_POLICY" || policyHit)) {
    return api || "Esta troca está fora da política da loja. Escolha outra variação ou volte e mude a resolução.";
  }
  if (status === 400) {
    return api || "Não foi possível confirmar. Revise os dados e tente de novo.";
  }
  if (status === 409 || status === 422) {
    return api || "Já existe uma solicitação para este pedido.";
  }
  return api || "Não foi possível processar a solicitação. Tente de novo em instantes.";
}
